// extracted by mini-css-extract-plugin
export default {"subheader":"Subheader__subheader___jfp5h","title":"Subheader__title___kTHcs","titleAndIcon":"Subheader__titleAndIcon___wQI02","hintButton":"Subheader__hintButton___PNl_j"};